import * as React from "react";
import { useCollapse } from "react-collapsed";

export default function Collapse({ isActive, children, name }) {
  const [isExpanded, setExpanded] = React.useState(isActive);
  const { getToggleProps, getCollapseProps } = useCollapse({
    isExpanded
  });

  React.useEffect(() => {
    setExpanded(isActive);
  }, [isActive, setExpanded]);

  return (
    <>
      <div
        {...getToggleProps({
          style: {
            display: "block",
            cursor: "pointer"
          },
          onClick: () => setExpanded((x) => !x)
        })}
      >
        <h1>{name}</h1>
        <hr></hr>
      </div>
      <div {...getCollapseProps()}>
        {children}
      </div>
    </>
  );
}